// $(document).mousemove(function () { return false });
export function $scroll() {
	this.scrollBox = $('.scroll');//滚动条外盒
	this.content = $('.wrap');//滚动内容
	this.el = $('.scroll span');//滚动条
	var _this = this;
	//初始化
	this.init = function () {
		this.moveS = this.scrollBox.outerHeight();//滚动条可移动范围
		this.contentH = this.content.outerHeight();//滚动条内容高度
		var rate = _this.moveS / _this.contentH;
		_this.scrollBarH = Math.ceil(rate * _this.moveS);
		_this.el.outerHeight(_this.scrollBarH);
		_this.moveT = 110;//初始化滚动距离
		_this.el.css('top', _this.moveT);
		var rate = (_this.moveT + _this.scrollBarH) / _this.moveS;
		var boxT = Math.ceil(rate * (_this.contentH - _this.scrollBox.position().top) - _this.moveS);
		if (boxT < 0) boxT = 0;
		_this.content.animate({ 'top': -boxT + 'px' }, 1000);
	}

	//mousedown
	this.el.mousedown(function (e) {
		var scrollTop = _this.el.offset().top;
		var tempT = e.pageY - scrollTop;
		function move(e) {
			var newTop = e.pageY - _this.scrollBox.offset().top - tempT;
			if (newTop <= 0) {
				newTop = 0;
			} else if (newTop >= _this.moveS - _this.scrollBarH) {
				newTop = _this.moveS - _this.scrollBarH;
			}
			var rate = (newTop + _this.scrollBarH) / _this.moveS;
			var boxT = Math.ceil(rate * (_this.contentH - _this.scrollBox.position().top) - _this.moveS);
			_this.el.css('top', newTop);
			if (boxT < 0) boxT = 0;
			_this.content.css('top', -boxT + 'px');
			_this.moveT = newTop;
		};
		$(document).on("mousemove", move);
		$(document).mouseleave(function () {
			$(document).off("mousemove", move);
		})
		$(document).mouseup(function () {
			$(document).off("mousemove", move);
		});
	})

	//mousewheel
	document.onmousewheel = function (e) {
		if (_this.scrollBox.css('display') == 'none') {
			return false;
		} else {
			_this.content.animate().stop();
			if (e.deltaY < 0 || e.wheelDelta > 0) {
				// console.log(_this.moveT)
				_this.moveT -= 20
				//up
			} else {
				_this.moveT += 20
				//down
			}
			if (_this.moveT < 0) {
				_this.moveT = 0;
			} else if (_this.moveT > _this.moveS - _this.scrollBarH) {
				_this.moveT = _this.moveS - _this.scrollBarH;
			}
			_this.el.css('top', _this.moveT);
			var rate = (_this.moveT + _this.scrollBarH) / _this.moveS;
			var boxT = Math.ceil(rate * (_this.contentH - _this.scrollBox.position().top) - _this.moveS);
			if (boxT < 0) boxT = 0;
			$('.message').hide();
			$('.to-top').show();
			_this.content.css('top', -boxT + 'px')
			if (boxT <= 550) {
				$('.message').show();
				$('.to-top').hide();
			}
		}
	};
	//侧导航
	$('.slider li').click(function () {
		$('.slider li').removeClass('active')
		$('.slider li').eq($(this).index()).addClass('active');
		$('.message').hide();
		$('.to-top').show();
		switch ($(this).index()) {
			case 1:
				_this.moveT = 320;
				break;
			case 2:
				_this.moveT = 480;
				break;
			case 3:
				_this.moveT = 530;
				break;
			case 4:
				_this.moveT = 0;
				break
			default:
				_this.moveT = 145;
				$('.message').show();
				$('.to-top').hide();

		}
		_this.el.css('top', _this.moveT);
		var rate = (_this.moveT + _this.scrollBarH) / _this.moveS;
		var boxT = Math.ceil(rate * (_this.contentH - _this.scrollBox.position().top) - _this.moveS);
		if (boxT < 0) boxT = 0;
		_this.content.animate({ 'top': -boxT + 'px' })
	})

	//特殊锚点
	this.to_buy = function () {
		$('.slider li').removeClass('active')
		$('.slider li').eq(2).addClass('active');
		$('.message').hide();
		$('.to-top').show();
		_this.moveT = 480;
		_this.el.css('top', _this.moveT);
		var rate = (_this.moveT + _this.scrollBarH) / _this.moveS;
		var boxT = Math.ceil(rate * (_this.contentH - _this.scrollBox.position().top) - _this.moveS);
		if (boxT < 0) boxT = 0;
		_this.content.animate({ 'top': -boxT + 'px' })
	}

	//返回顶部
	$('.to-top').click(function () {
		$('.slider li').removeClass('active')
		$('.slider li').eq(0).addClass('active');
		$('.message').show();
		$('.to-top').hide();
		_this.moveT = 0;
		_this.el.css('top', _this.moveT);
		var rate = (_this.moveT + _this.scrollBarH) / _this.moveS;
		var boxT = Math.ceil(rate * (_this.contentH - _this.scrollBox.position().top) - _this.moveS);
		if (boxT < 0) boxT = 0;
		_this.content.animate({ 'top': -boxT + 'px' })
	})
}



// WEBPACK FOOTER //
// ./src/assets/js/scroll.js